<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" translate>
    {{"APP.AppConfirmmodalTitlehead_Confirm" | translate: {Default: "Confirm"} }}
  </h4>
</div>
<div class="modal-body" translate>
  {{"APP.AppConfirmmodalTitle_Areyousureyouwanttoleavethisscreenbeforesavingyour" | translate: {Default: "Are you sure you want to leave this screen before saving your changes?"} }}
</div>
<div class="modal-footer">
  <button type="button" #yesAction id="yesAction" class="fdx-c-button fdx-c-button--secondary" (click)="action(true)">
    {{"APP.AppButton_Yes" | translate: {Default: "Yes"} }}
  </button>
  <button type="button" class="fdx-c-button fdx-c-button--secondary-outline" (click)="action(false)">
    {{"APP.AppButton_No" | translate: {Default: "No"} }}
  </button>
</div>